import { FC } from 'react'

import { SpinLoading } from 'antd-mobile'

import { cn } from '@/utils'

interface ILoadingStateProps {
  show: boolean
  className?: string
  size?: string
}

const LoadingState: FC<ILoadingStateProps> = ({ show, className, size = '16px' }) => {
  if (!show) {
    return null
  }

  return (
    <div className={cn('flex justify-center', className)}>
      <SpinLoading style={{ '--size': size }} />
    </div>
  )
}

export default LoadingState
